import { getPlantingEventAggregates } from '../../queries/plantingEventAggregates';
import { requestGraphQL } from '../../utils/request';
import { parsePlantingData } from './selectors';
import { PlantingEventAggregatesResponse, PlantingEvents } from '../../types/Planting';

export async function requestPlantingEvents(fieldUuid: string): Promise<PlantingEvents> {
  const response = (await requestGraphQL(getPlantingEventAggregates({ fieldUUID: fieldUuid }), {
    version: '2',
  })) as PlantingEventAggregatesResponse;
  
  return parsePlantingData(response.data.field.plantingAnalytics.plantingEventsAggregate);
}
